import BodyText from 'LuxKit/Typography/BodyText'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import useCruiseSearchCount from 'hooks/Cruise/useCruiseSearchCount'
import { EmptyArray } from 'lib/array/arrayUtils'
import { useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { getCruiseOfferFiltersFromParams } from 'lib/cruises/cruiseUtils'
import useQueryParams from 'hooks/useQueryParams'
import useCruiseSearchMpvRankingFilters from 'hooks/Cruise/useCruiseSearchMpvRankingFilters'

interface Props {
  initialFilters?: App.OfferListFilters
}

function FormattedCruiseLineSearchSummary({ initialFilters }: Props) {
  const intl = useIntl()
  const queryParams = useQueryParams()
  const globalFilters = useContext(GlobalSearchStateContext)
  const {
    cruiseLines,
    searchItems,
    secondarySearchItems,
    durationMax,
    durationMin,
    flexibleMonths,
    checkinDate,
    checkoutDate,
    durationRange,
  } = globalFilters
  const [filters] = useMemo(() => getCruiseOfferFiltersFromParams(queryParams), [queryParams])

  const countFilters = useCruiseSearchMpvRankingFilters({
    ...filters,
    cruiseLines,
    destinationIds: searchItems.map(({ value }) => value),
    departureIds: secondarySearchItems.map(({ value }) => value),
    durationMin,
    durationMax,
    durationRange,
    departureMonths: flexibleMonths?.split(',') || EmptyArray,
    ...(!!checkinDate && !!checkoutDate && {
      departureStartDate: checkinDate.format(ISO_DATE_FORMAT),
      departureEndDate: checkoutDate.format(ISO_DATE_FORMAT),
    }),
    ...(initialFilters || {}),
  })
  const [searchCount, fetchingSearchCount] = useCruiseSearchCount(countFilters)

  return <BodyText data-testid="cruise-filter-footer-available-results" variant="medium">
    {!fetchingSearchCount && intl.formatMessage(
      {
        id: 'rj2h5NJJezsJDRv-DI8_',
        defaultMessage: '{count, plural, one {# cruise} other {# cruises}} available',
      },
      { count: searchCount },
    )}
    {fetchingSearchCount && <TextLoadingBox width="16ch" />}
  </BodyText>
}

export default FormattedCruiseLineSearchSummary
